export interface MovieItem {
  id: string;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  categoryLabel: string;
  tags: string[];
  year: number;
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  updateInfo: string;
  featured: boolean;
  trending: boolean;
  latest: boolean;
  hotRank?: number;
}

export const categories = [
  { slug: 'movie', label: '电影', icon: 'ri-movie-2-line' },
  { slug: 'tv', label: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'variety', label: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', label: '动漫', icon: 'ri-rocket-line' },
];

export const allMovies: MovieItem[] = [
  {
    id: 'movie-001',
    title: '流浪地球3',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['科幻', '冒险', '灾难'],
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20earth%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20poster%20style%2C%20dark%20background%20with%20warm%20orange%20accents%2C%20movie%20poster%20design%20with%20Chinese%20title%20space&width=600&height=800&seq=movie-001&orientation=portrait',
    description: '太阳急速衰老膨胀，人类面临灭顶之灾。为了生存，人类提出"流浪地球"计划，在地球表面建造上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的比邻星。第三部讲述了地球在漫长宇宙漂流中遭遇的全新危机与挑战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '宁理'],
    region: '中国大陆',
    updateInfo: '2026年春节档上映',
    featured: true,
    trending: true,
    latest: false,
    hotRank: 1,
  },
  {
    id: 'movie-002',
    title: '热烈2',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['剧情', '喜剧', '青春'],
    year: 2026,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20dance%20movie%20poster%20with%20street%20dancer%20in%20dynamic%20pose%2C%20vibrant%20colors%2C%20urban%20night%20background%2C%20cinematic%20lighting%2C%20movie%20poster%20design%20with%20energy%20and%20movement&width=600&height=800&seq=movie-002&orientation=portrait',
    description: '街舞少年陈烁偶遇了伯乐丁雷，加入了"惊叹号"舞团。面对家庭和梦想的双重压力，陈烁用汗水和热爱证明了自己，带领舞团登上了全国街舞大赛的舞台。',
    director: '大鹏',
    actors: ['黄渤', '王一博', '刘敏涛'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: true,
    trending: true,
    latest: false,
    hotRank: 2,
  },
  {
    id: 'movie-003',
    title: '满江红2',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['悬疑', '历史', '剧情'],
    year: 2026,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20with%20ancient%20Chinese%20courtyard%20and%20lanterns%2C%20dark%20moody%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-003&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后第四年。秦桧率兵与金国会谈，会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被裹挟进这场巨大阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: false,
    trending: true,
    latest: false,
    hotRank: 3,
  },
  {
    id: 'movie-004',
    title: '哪吒之魔童闹海',
    category: 'anime',
    categoryLabel: '动漫',
    tags: ['动画', '奇幻', '神话'],
    year: 2025,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20a%20mythological%20boy%20warrior%20with%20flaming%20hair%20and%20red%20ribbon%2C%20epic%20fantasy%20style%2C%20Chinese%20mythology%20aesthetic%2C%20vibrant%20colors%2C%20cinematic%20animation%20poster&width=600&height=800&seq=movie-004&orientation=portrait',
    description: '天地灵气孕育出一颗混元珠，元始天尊将其分为灵珠和魔丸。灵珠投胎为人，助周伐纣；魔丸则会诞出魔王，为祸人间。然而阴差阳错，灵珠和魔丸被调包，哪吒成为了魔丸转世。面对命运的不公，哪吒喊出"我命由我不由天"！',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '陈浩'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: true,
    trending: true,
    latest: false,
    hotRank: 4,
  },
  {
    id: 'tv-001',
    title: '繁花2',
    category: 'tv',
    categoryLabel: '电视剧',
    tags: ['剧情', '年代', '商战'],
    year: 2026,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20neon%20night%20cityscape%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20Chinese%20TV%20drama%20poster%20style&width=600&height=800&seq=tv-001&orientation=portrait',
    description: '九十年代的上海，青年阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人争相传颂着他的传奇故事。然而，机遇与风险并存，在这片充满魔力的土地上，每个人都在书写自己的人生。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    updateInfo: '更新至24集',
    featured: true,
    trending: true,
    latest: true,
    hotRank: 5,
  },
  {
    id: 'tv-002',
    title: '庆余年3',
    category: 'tv',
    categoryLabel: '电视剧',
    tags: ['古装', '权谋', '喜剧'],
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%20with%20ancient%20Chinese%20palace%20and%20warrior%20figure%2C%20dramatic%20composition%2C%20rich%20colors%2C%20epic%20Chinese%20costume%20drama%20style&width=600&height=800&seq=tv-002&orientation=portrait',
    description: '范闲历经家族、江湖、庙堂的种种考验与锤炼，书写了一段光彩夺目的人生传奇。第三部中，范闲将面临更为严峻的权力博弈，庆帝的阴谋也渐渐浮出水面。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    updateInfo: '更新至32集',
    featured: true,
    trending: false,
    latest: true,
    hotRank: 6,
  },
  {
    id: 'tv-003',
    title: '三体2：黑暗森林',
    category: 'tv',
    categoryLabel: '电视剧',
    tags: ['科幻', '悬疑', '剧情'],
    year: 2026,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20dark%20forest%20concept%2C%20mysterious%20universe%20background%2C%20stars%20and%20galaxy%2C%20dark%20and%20contemplative%20mood%2C%20Chinese%20sci-fi%20drama%20poster&width=600&height=800&seq=tv-003&orientation=portrait',
    description: '三体人在利用智子锁死地球基础科学后，庞大的宇宙舰队开始向地球进发。人类面临前所未有的危机，面壁计划启动，四位面壁者开始与三体文明展开一场跨越时空的殊死博弈。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    updateInfo: '更新至16集',
    featured: true,
    trending: true,
    latest: true,
    hotRank: 7,
  },
  {
    id: 'movie-005',
    title: '飞驰人生3',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['喜剧', '运动', '剧情'],
    year: 2026,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20on%20track%2C%20dust%20and%20speed%20effect%2C%20dynamic%20action%20shot%2C%20warm%20desert%20tones%2C%20Chinese%20movie%20poster%20design&width=600&height=800&seq=movie-005&orientation=portrait',
    description: '曾经的拉力赛冠军张驰，为了重返赛场经历重重困难。第三部中，张驰带领全新团队征战国际拉力赛场，面对更强大的对手和更恶劣的赛道环境，用速度与激情诠释人生。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: false,
    trending: true,
    latest: false,
    hotRank: 8,
  },
  {
    id: 'variety-001',
    title: '乘风破浪的姐姐5',
    category: 'variety',
    categoryLabel: '综艺',
    tags: ['音乐', '真人秀', '竞技'],
    year: 2026,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20elegant%20women%20on%20stage%2C%20glamorous%20lighting%2C%20music%20performance%20theme%2C%20bright%20and%20colorful%2C%20Chinese%20entertainment%20show%20poster&width=600&height=800&seq=variety-001&orientation=portrait',
    description: '30位30+姐姐再次集结，通过唱跳竞演展现成熟女性的魅力与力量。第五季全新升级，更激烈的赛制，更精彩的舞台，姐姐们将用实力证明，年龄从来不是限制。',
    director: '吴梦知',
    actors: ['宁静', '那英', '王心凌', '薛凯琪'],
    region: '中国大陆',
    updateInfo: '更新至第10期',
    featured: false,
    trending: true,
    latest: true,
    hotRank: 9,
  },
  {
    id: 'anime-002',
    title: '斗破苍穹年番',
    category: 'anime',
    categoryLabel: '动漫',
    tags: ['玄幻', '热血', '战斗'],
    year: 2026,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%20with%20martial%20arts%20fantasy%20warrior%20holding%20flame%2C%20epic%20battle%20scene%2C%20ancient%20Chinese%20fantasy%20setting%2C%20dramatic%20lighting%2C%20animation%20poster%20style&width=600&height=800&seq=anime-002&orientation=portrait',
    description: '萧炎，曾经的天才少年，因斗气全失沦为废柴。在药老的指导下，萧炎重拾信心，踏上了逆天改命的修炼之路。从加玛帝国到中州大陆，从斗者到斗帝，一段热血的玄幻传奇正在上演。',
    director: '赵丙乐',
    actors: ['张沛', '刘明月', '宝木中阳'],
    region: '中国大陆',
    updateInfo: '更新至86集',
    featured: false,
    trending: true,
    latest: true,
    hotRank: 10,
  },
  {
    id: 'movie-006',
    title: '长津湖之水门桥',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['战争', '历史', '剧情'],
    year: 2025,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20in%20snowy%20battlefield%2C%20heroic%20composition%2C%20cold%20winter%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20Chinese%20historical%20war%20film%20poster&width=600&height=800&seq=movie-006&orientation=portrait',
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了中国人民志愿军第九兵团七连战士们在结束了新兴里和下碣隅里的战斗之后，又接到了更艰巨的任务——炸毁水门桥，阻止美军撤退。',
    director: '陈凯歌、徐克、林超贤',
    actors: ['吴京', '易烊千玺', '朱亚文', '李晨'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: false,
    trending: false,
    latest: false,
    hotRank: 11,
  },
  {
    id: 'tv-004',
    title: '长安十二时辰2',
    category: 'tv',
    categoryLabel: '电视剧',
    tags: ['古装', '悬疑', '动作'],
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20TV%20drama%20poster%20with%20ancient%20Tang%20dynasty%20city%20at%20night%2C%20lanterns%20and%20shadows%2C%20mysterious%20atmosphere%2C%20Chinese%20costume%20drama%20poster&width=600&height=800&seq=tv-004&orientation=portrait',
    description: '唐天宝三年，上元节前夕，长安城混入可疑人员。死囚张小敬临危受命，与少年名士李必携手在十二个时辰内拯救长安。第二部再度展开惊心动魄的危机化解之旅。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围'],
    region: '中国大陆',
    updateInfo: '即将上线',
    featured: false,
    trending: false,
    latest: true,
    hotRank: 12,
  },
  {
    id: 'movie-007',
    title: '独行月球2',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['科幻', '喜剧', '剧情'],
    year: 2026,
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%20with%20astronaut%20and%20kangaroo%20on%20moon%20surface%2C%20humorous%20tone%2C%20space%20background%2C%20bright%20and%20playful%2C%20Chinese%20movie%20poster%20design&width=600&height=800&seq=movie-007&orientation=portrait',
    description: '人类为抵御小行星撞击，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因意外错过了撤离通知，一个人被留在了月球上。第二部讲述独孤月回地球后的全新冒险。',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '黄才伦'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: false,
    trending: false,
    latest: false,
    hotRank: 13,
  },
  {
    id: 'variety-002',
    title: '奔跑吧第12季',
    category: 'variety',
    categoryLabel: '综艺',
    tags: ['真人秀', '游戏', '户外'],
    year: 2026,
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20sunny%20day%2C%20energetic%20and%20fun%20atmosphere%2C%20Chinese%20entertainment%20poster%20style&width=600&height=800&seq=variety-002&orientation=portrait',
    description: '大型户外竞技真人秀，常驻嘉宾与飞行嘉宾一起完成各种趣味挑战任务。全新一季带来更多创意游戏和极限挑战，在欢笑中展现团队精神。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '白鹿'],
    region: '中国大陆',
    updateInfo: '更新至第8期',
    featured: false,
    trending: false,
    latest: true,
    hotRank: 14,
  },
  {
    id: 'anime-003',
    title: '完美世界',
    category: 'anime',
    categoryLabel: '动漫',
    tags: ['玄幻', '修仙', '冒险'],
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20fantasy%20anime%20poster%20with%20young%20cultivator%20in%20ancient%20mythical%20world%2C%20magical%20elements%2C%20epic%20landscape%2C%20Chinese%20animation%20style%2C%20vibrant%20and%20mystical&width=600&height=800&seq=anime-003&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。石昊出生于荒域，天生至尊却遭人暗算，至尊骨被夺。但他凭借不屈意志一步步修炼，从大荒中走出，踏上了成为荒天帝的逆天之路。',
    director: '汪成果',
    actors: ['锦鲤', '张杰', '季冠霖'],
    region: '中国大陆',
    updateInfo: '更新至142集',
    featured: false,
    trending: false,
    latest: false,
    hotRank: 15,
  },
  {
    id: 'movie-008',
    title: '封神第三部',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['奇幻', '神话', '战争'],
    year: 2026,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20gods%20and%20warriors%20in%20epic%20battle%2C%20mythical%20creatures%2C%20dramatic%20sky%2C%20cinematic%20style%2C%20grand%20scale&width=600&height=800&seq=movie-008&orientation=portrait',
    description: '商王殷寿暴虐无道，天谴降临。姬发觉醒，率领八百诸侯伐商。人、神、妖三界大战一触即发，封神榜的最终归属即将揭晓。第三部将为这场史诗神话画上壮丽句号。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: false,
    trending: false,
    latest: false,
    hotRank: 16,
  },
  {
    id: 'anime-004',
    title: '凡人修仙传',
    category: 'anime',
    categoryLabel: '动漫',
    tags: ['修仙', '奇幻', '冒险'],
    year: 2026,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20cultivation%20anime%20poster%20with%20swordsman%20in%20misty%20mountain%2C%20ancient%20Chinese%20fantasy%20aesthetic%2C%20elegant%20and%20mysterious%2C%20ink%20wash%20painting%20style%20inspired&width=600&height=800&seq=anime-004&orientation=portrait',
    description: '一个普通的山村穷小子韩立，偶然之下跨入一个江湖小门派，虽然资质平庸，但依靠自身努力和合理算计，最终修炼成仙。这是一段凡人逆天改命的修仙史诗。',
    director: '王裕仁',
    actors: ['钱文青', '杨天翔', '乔诗语'],
    region: '中国大陆',
    updateInfo: '更新至98集',
    featured: false,
    trending: false,
    latest: true,
    hotRank: 17,
  },
  {
    id: 'tv-005',
    title: '狂飙2',
    category: 'tv',
    categoryLabel: '电视剧',
    tags: ['犯罪', '剧情', '扫黑'],
    year: 2026,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20dark%20urban%20night%20scene%2C%20police%20and%20underworld%20confrontation%2C%20tense%20atmosphere%2C%20Chinese%20TV%20drama%20thriller%20style&width=600&height=800&seq=tv-005&orientation=portrait',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开了长达二十年的生死较量。第二部聚焦扫黑除恶常态化的新战场，正义与邪恶的较量永不停歇。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    updateInfo: '更新至28集',
    featured: false,
    trending: true,
    latest: true,
    hotRank: 18,
  },
  {
    id: 'variety-003',
    title: '向往的生活8',
    category: 'variety',
    categoryLabel: '综艺',
    tags: ['生活', '美食', '慢综艺'],
    year: 2026,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20slow-paced%20variety%20show%20poster%20with%20countryside%20farmhouse%2C%20green%20fields%20and%20mountains%2C%20warm%20and%20cozy%20atmosphere%2C%20natural%20light%2C%20Chinese%20lifestyle%20show%20poster&width=600&height=800&seq=variety-003&orientation=portrait',
    description: '黄磊、何炅与家人朋友们回归田园，在蘑菇屋中自给自足，招待远道而来的客人。第八季全新选址，在更美的自然风光中，继续讲述温暖治愈的生活故事。',
    director: '王征宇',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    region: '中国大陆',
    updateInfo: '更新至第14期',
    featured: false,
    trending: false,
    latest: true,
    hotRank: 19,
  },
  {
    id: 'movie-009',
    title: '志愿军：存亡之战',
    category: 'movie',
    categoryLabel: '电影',
    tags: ['战争', '历史', '剧情'],
    year: 2025,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20epic%20movie%20poster%20with%20soldiers%20marching%20in%20formation%2C%20dramatic%20battlefield%20smoke%2C%20heroic%20and%20solemn%20tone%2C%20Chinese%20historical%20war%20film%20poster&width=600&height=800&seq=movie-009&orientation=portrait',
    description: '聚焦抗美援朝战争第五次战役中的铁原阻击战。中国人民志愿军第63军2.5万将士与近5万"联合国军"激战12昼夜，在铁原战场上构筑了一道冲不破的钢铁长城。',
    director: '陈凯歌',
    actors: ['朱一龙', '辛柏青', '张子枫', '吴京'],
    region: '中国大陆',
    updateInfo: '已上线',
    featured: false,
    trending: false,
    latest: false,
    hotRank: 20,
  },
];

export const getFeaturedMovies = (): MovieItem[] => allMovies.filter(m => m.featured);
export const getTrendingMovies = (): MovieItem[] => allMovies.filter(m => m.trending);
export const getLatestMovies = (): MovieItem[] => allMovies.filter(m => m.latest);
export const getMoviesByCategory = (slug: string): MovieItem[] => allMovies.filter(m => m.category === slug);
export const getMovieById = (id: string): MovieItem | undefined => allMovies.find(m => m.id === id);